export default __webpack_public_path__ + "static/media/Frankfurter.587b6794.ttf";